import { h, Component } from 'preact';
import { Text } from 'preact-i18n';


export default class IconBar extends Component {

	render(props) {
		var classStyle = 'animatedIconBar_'+this.props.percent
		return (
      <svg width="304" height="238" viewBox="0 0 304 238" fill="none" xmlns="http://www.w3.org/2000/svg" width="80%" style="padding-top: 14%;margin-bottom: 12%;">
          <rect class="icon_card_frame" x="0.5" y="0.5" width="125.667" height="237" rx="4.5" stroke="#efefef"/>
          <rect class="icon_card_bar_background" x="17.9443" y="49.2065" width="88.6667" height="24.1013" rx="3" fill={props.color}/>
          <text x="28" y="118" fill={props.color} style="font-size:43px; font-weight:400">{props.number}</text>
          <text x="45" y="151.5" fill="#4A4A4A" style="font-size: 12px; font-weight: 500">Mbit/s</text>
          <rect class="icon_card_arrows" x="43.2778" y="185.781" width="7.38889" height="11.0464" fill="#EEEEEE"/>
          <path class="icon_card_arrows" d="M46.9721 205.865L55.6564 196.074H38.2878L46.9721 205.865Z" fill="#EEEEEE"/>
          <rect class="icon_card_arrows" width="7.38889" height="11.0464" transform="matrix(-1 0.000438742 -0.000484746 -1 80.2319 203.859)" fill="#EEEEEE"/>
          <path class="icon_card_arrows" d="M76.5279 183.776L67.8483 193.571L85.2169 193.564L76.5279 183.776Z" fill="#EEEEEE"/>
          <text x="35" y="68.5" fill="white" style="font-size: 18px; font-weight: 400; letter-spacing: 0.35em;"><Text id="iconBar"/></text>
					<mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse" x="158" y="83" width="147" height="62">
					<path d="M193.5 143.5L158.333 129.906C158.333 129.906 179.445 83.35 231.167 83.3501C288.167 83.3503 304 130.886 304 130.886L267.583 144.607C267.583 144.607 259 122 232 119.5C205 117 193.5 143.5 193.5 143.5Z" fill="#EEEEEE"/>
					</mask>
					<path d="M193.5 143.5L158.333 129.906C158.333 129.906 179.445 83.35 231.167 83.3501C288.167 83.3503 304 130.886 304 130.886L267.583 144.607C267.583 144.607 259 122 232 119.5C205 117 193.5 143.5 193.5 143.5Z" fill="#e2e2e2"></path>
					<g mask="url(#mask0)">
					   <path class="icon_bar_animated" className={classStyle} d="M189.963 167.326L152.692 176.659C152.692 176.659 143.297 126.411 185.674 96.7577C232.376 64.0782 272.602 93.9476 272.602 93.9476L250.632 126.069C250.632 126.069 233.513 111.73 209.622 125.458C186.916 138.504 189.963 167.326 189.963 167.326Z" fill={props.color}/>
					</g>
          <path class="icon_bar_arrow" className={classStyle} d="M228.181 153.69C222.807 161.884 225.365 163.632 226.487 163.915C227.93 164.28 230.168 165.947 235.278 157.319C254.001 125.703 279.85 83.3503 279.85 83.3503C279.85 83.3503 235.467 142.582 228.181 153.69Z" fill="#4C4C4C"/>
      </svg>
    )
  }
}



// WEBPACK FOOTER //
// ./components/iconBar.js